import React, { Component } from "react";
import { Grid, Row, Col } from "react-bootstrap";

import { Query } from "react-apollo";
import gql from "graphql-tag";
import { ApolloClient } from 'apollo-client';
import { InMemoryCache } from 'apollo-cache-inmemory';
import HttpLinkServices from "../../services/HttpLinkServices";
import Config from "../../config/config";
import { addToDataLayerGTM } from '../../utils/addToDataLayerGTM';
import { formattedCurrentDate } from '../../utils/dateFormat';
import SearchNotFound from "../../components/SearchNotFound";
import ErrorModal from "../../components/Modal/ErrorModal";
import banner_default from '../../assets/img/trilhas_Certificados2021.jpg';

const lms_client = new ApolloClient({
  link: HttpLinkServices.lms,
  cache: new InMemoryCache(),
});

const GET_CERTIFICATES = gql`{
  trail_has_user{
    trailhasuser{
      id,
      trail{
        id,
        title,
        thumbnail
      }
    }
  }
}
`;

class CertificateTrailList extends Component {
  createLegend(json) {
    var legend = [];
    for (var i = 0; i < json["names"].length; i++) {
      var type = "fa fa-circle text-" + json["types"][i];
      legend.push(<i className={type} key={i} />);
      legend.push(" ");
      legend.push(json["names"][i]);
    }
    return legend;
  }

  componentDidMount() {
    // Google Tag Manager
    const dataLayer = {
      'event': 'step_change',
      'etapa': '/cursos/certificados-das-trilhas/',
    }

    addToDataLayerGTM(dataLayer)
  }

  handleGenerateCertificateGTM(id, courseTitle){
    // Google Tag Manager
    const dataLayer = {
     event: 'solicitacao_servico',
     nome_servico: 'gerar_certificado:cursos',
     nome_curso: courseTitle,
     data_servico: formattedCurrentDate(),
     produto: courseTitle,
     brand: 'porto seguro',
     retorno: Config.baseUrl && id ? 'sucesso' : 'erro',
     descricao: Config.baseUrl && id ? 'certificado gerado': 'certificado não gerado'
   }

   addToDataLayerGTM(dataLayer)
 }

  render() {
    return (
      <div>
        <Query
          client={lms_client}
          query={GET_CERTIFICATES}
        >
        {({ loading, error, data }) => {
          if (loading) return <div>Carregando...</div>;
          if (error){
            // Google Tag Manager
            addToDataLayerGTM({
              'event' : 'erro',
              'etapa' : 'erro ao buscar categorias'
            });
            return <ErrorModal />;
          };

            return (
              <img className="banner_content" src={data.category && data.category.banner ? Config.baseUrl + "/dam/assets/" + data.category.banner : banner_default} />
            );
          }}
        </Query>
        <div className="content">
          <div className="container">
            <Grid fluid>
              <Row>
                <Query
                  client={lms_client}
                  query={GET_CERTIFICATES}
                >
                  {({ loading, error, data }) => {
                    if (loading) return <div>Carregando...</div>;
                    if (error) {
                      // Google Tag Manager
                      addToDataLayerGTM({
                        'event' : 'erro',
                        'etapa' : 'erro ao buscar os certificados'
                      });
                      return <ErrorModal />;
                    };

                    if (!data.trail_has_user || !data.trail_has_user.trailhasuser.length) {
                      return (<SearchNotFound
                        message="Você não tem certificados de trilhas."
                        onClick={() => window.location.href = "/#/home"}
                        buttonMessage="Voltar a página inicial"
                      />)
                    }

                    return data.trail_has_user.trailhasuser.map((cursehasuser) => (
                      <Col lg={4} sm={6} className="col" key={cursehasuser.id}>
                        <div className="media">
                          <img src={Config.baseUrl + "/lms/assets/" + cursehasuser.trail.thumbnail} />
                          <div>{cursehasuser.trail.title}</div>
                          <a
                            data-gtm-type="click"
                            data-gtm-clicktype="download"
                            data-gtm-name={"Certificado Trilha - " + cursehasuser.trail.title}
                            target="_blank" download className="btn"
                            href={`${Config.baseUrl}/api/v1/lms/certified_trail_generat/?u=${cursehasuser.id}`}
                            onClick={() => this.handleGenerateCertificateGTM(cursehasuser.id, cursehasuser.course.title)}>
                            Gerar Certificado
                        </a>
                        </div>
                      </Col>
                    ));
                  }}
                </Query>
              </Row>
            </Grid>
          </div>
        </div>
      </div>
    );
  }
}

export default CertificateTrailList;



// WEBPACK FOOTER //
// ./src/views/Certificate/CertificateTrailList.jsx